import React, { useState } from "react";
import { generateAppToken } from "../../lib/apiClient";

const cardStyle = {
  border: "1px solid #ddd",
  borderRadius: "8px",
  padding: "24px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  marginBottom: "24px",
};

const buttonStyle = {
  backgroundColor: "#007bff",
  color: "white",
  border: "none",
  padding: "12px 24px",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "16px",
};

const ToolsPage: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const executeAppLaunch = async (protocol: string) => {
    try {
      setIsLoading(true);
      const newAuthData = await generateAppToken();
      const encodedData = encodeURIComponent(JSON.stringify(newAuthData));

      window.location.href = `${protocol}://auth?token=${encodedData}`;
    } catch (error) {
      console.error("Lỗi cấp quyền Desktop App:", error);
      alert(
        "Lỗi khi kết nối đến ứng dụng Desktop. Vui lòng thử đăng nhập lại!",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenSigner = () => {
    if (isLoading) return;
    executeAppLaunch("tktesigner");
  };

  const handleOpenScanner = () => {
    if (isLoading) return;
    executeAppLaunch("tktescanner");
  };

  return (
    <div style={{ padding: "40px" }}>
      <h1>Công cụ & Cài đặt</h1>
      <div style={cardStyle}>
        <h2>Ứng dụng máy quét TKTe Archive</h2>
        <p>
          Nhấn vào nút bên dưới để khởi chạy ứng dụng máy quét TKTe Archive được
          cài đặt trên máy tính của bạn.
        </p>
        <p style={{ fontStyle: "italic", color: "#666" }}>
          Lưu ý: Bạn phải cài đặt ứng dụng máy quét trên máy tính của mình trước
          khi nhấn nút này.
        </p>
        <div>
          <button
            style={{ ...buttonStyle, opacity: isLoading ? 0.6 : 1 }}
            onClick={handleOpenSigner}
            disabled={isLoading}
          >
            {isLoading ? "Đang mở..." : "Mở công cụ Ký (Signer)"}
          </button>
          <span style={{ margin: "0 12px" }}></span>
          <button
            style={{ ...buttonStyle, opacity: isLoading ? 0.6 : 1 }}
            onClick={handleOpenScanner}
            disabled={isLoading}
          >
            {isLoading ? "Đang mở..." : "Mở máy quét Archive (Scanner)"}
          </button>
        </div>
      </div>

      <div style={cardStyle}>
        <h2>Tải về ứng dụng</h2>
        <p>
          Tải xuống phiên bản mới nhất của ứng dụng máy quét TKTe Archive cho hệ
          điều hành của bạn.
        </p>
        <button style={{ ...buttonStyle, backgroundColor: "#28a745" }}>
          Tải xuống Windows (.exe)
        </button>
      </div>
    </div>
  );
};

export default ToolsPage;
